import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Home } from "lucide-react";

const STATUS = { loue: "Loué", vacant: "Vacant", vente: "En vente", en_travaux: "En travaux" };
const COLOR = { loue: "#059669", vacant: "#D97706", vente: "#002FA7", en_travaux: "#7C3AED" };
const TYPES = { appartement: "Appartement", maison: "Maison", local: "Local commercial", terrain: "Terrain", garage: "Garage / Parking" };

export default function ChefBiens() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/biens"
      eyebrow="Immobilier · Biens"
      title="Portefeuille immobilier"
      sub="Gérez vos biens, baux et locataires en un seul endroit."
      testidPrefix="bien"
      allowEdit
      defaultRow={() => ({ reference: "", adresse: "", type_bien: "appartement", surface_m2: 0, nb_pieces: 0, locataire_nom: "", locataire_email: "", bail_debut: "", bail_fin: "", loyer_mensuel: 0, charges: 0, status: "loue", notes: "" })}
      columns={[
        { key: "reference", label: "Réf.", width: "100px", render: (v) => <span className="font-mono font-bold uppercase">{v}</span> },
        { key: "adresse", label: "Adresse" },
        { key: "type_bien", label: "Type", width: "130px", render: (v) => TYPES[v] || v },
        { key: "surface_m2", label: "m²", width: "70px" },
        { key: "loyer_mensuel", label: "Loyer/m", width: "100px", render: (v) => <span className="font-mono">{(v || 0).toLocaleString("fr-FR")} €</span> },
        { key: "locataire_nom", label: "Locataire", width: "150px" },
        { key: "status", label: "Statut", width: "100px", render: (v) => <span className="text-[9px] uppercase font-bold px-2 py-0.5" style={{ color: COLOR[v], background: `${COLOR[v]}15` }}>{STATUS[v] || v}</span> },
      ]}
      fields={[
        { key: "reference", label: "Référence interne", span: 4, required: true, placeholder: "BIEN-001" },
        { key: "type_bien", label: "Type", type: "select", span: 4, options: Object.entries(TYPES).map(([v, l]) => ({ value: v, label: l })) },
        { key: "status", label: "Statut", type: "select", span: 4, options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "adresse", label: "Adresse complète", span: 12, required: true },
        { key: "surface_m2", label: "Surface (m²)", type: "number", step: "0.01", span: 4 },
        { key: "nb_pieces", label: "Nb pièces", type: "number", span: 4 },
        { key: "loyer_mensuel", label: "Loyer mensuel (€)", type: "number", step: "0.01", span: 4 },
        { key: "locataire_nom", label: "Locataire", span: 6 },
        { key: "locataire_email", label: "Email locataire", span: 6 },
        { key: "bail_debut", label: "Début bail", type: "date", span: 6 },
        { key: "bail_fin", label: "Fin bail", type: "date", span: 6 },
        { key: "charges", label: "Charges (€)", type: "number", step: "0.01", span: 6 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Home}
      emptyText="Aucun bien. Cliquez sur Ajouter."
    />
  );
}
